<form [formGroup]="form" class="d-flex flex-column">
  <app-custom-image-uploader
    size="FULL"
    formControlName="imageUrl"
    [storageFolder]="storageFolder"
    [label]="label"
    [tooltip]="tooltip"
    [isDisabled]="isDisabled"
    [isClearable]="isClearable"
    [hasCropper]="hasCropper"
    [aspectRatio]="aspectRatio"
  >
    <div
      *ngIf="!!form.controls.imageUrl.value"
      ngProjectAs="settings"
      class="d-flex flex-column"
    >
      <lib-form-label [label]="'common.file.paddingLabel' | transloco"></lib-form-label>
      <div class="padding-form">
        <div class="padding-form__item">
          <app-input
            type="number"
            [control]="form.controls.paddingLeft"
            [trimOnFocusOut]="false"
            [placeholder]="'common.file.left' | transloco"
          ></app-input>

          <app-input
            type="number"
            [control]="form.controls.paddingRight"
            [trimOnFocusOut]="false"
            [placeholder]="'common.file.right' | transloco"
          ></app-input>
        </div>

        <div class="padding-form__item">
          <app-input
            type="number"
            [control]="form.controls.paddingTop"
            [trimOnFocusOut]="false"
            [placeholder]="'common.file.top' | transloco"
          ></app-input>

          <app-input
            type="number"
            [control]="form.controls.paddingBottom"
            [trimOnFocusOut]="false"
            [placeholder]="'common.file.bottom' | transloco"
          ></app-input>
        </div>
      </div>
    </div>
  </app-custom-image-uploader>
</form>
